import { NgModule } from '@angular/core';
import { UploadDocumentsComponent } from './upload-documents.component';
import { UploadDocumentsV2Component } from './upload-documents-v2.component';
import { SharedModule } from '../shared.module';
import { UploadFilesModule } from '../upload-files/upload-files.module';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { UploadProofOfPaymentModule } from '../upload-proof-of-payment/upload-proof-of-payment.module';
import { TreoMessageModule } from '@treo/components/message';
import { UploadPassportV2Component } from './upload-passport-v2.component';
import { UploadPassportModule } from '../upload-passport/upload-passport.module';

@NgModule({
  declarations: [
    UploadDocumentsComponent,
    UploadDocumentsV2Component,
    UploadPassportV2Component,
  ],
  imports: [
    SharedModule,
    UploadFilesModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
    UploadProofOfPaymentModule,
    UploadPassportModule,
    TreoMessageModule,
    UploadPassportModule,
  ],
  exports: [
    UploadDocumentsComponent,
    UploadDocumentsV2Component,
    UploadPassportV2Component,
  ],
})
export class UploadDocumentsModule {}
